var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["c-input-container", { "-has-error": !!_vm.displayValidation }],
      on: {
        "~input": function($event) {
          _vm.touched = true
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "group" },
        [
          _vm.label
            ? _c("label", { staticClass: "label" }, [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
                _vm.required
                  ? _c("span", { staticClass: "required" }, [
                      _vm._v("\n        *\n      ")
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._t("label-content")
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.displayValidation
        ? _c(
            "p",
            {
              staticClass: "validation",
              attrs: { "data-cy": "cinput-validation" }
            },
            [
              _c("c-icon", {
                staticClass: "icon",
                attrs: { icon: "warning-circle", size: "15" }
              }),
              _vm._v("\n    " + _vm._s(_vm.validation) + "\n  ")
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70aea8c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70aea8c4","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CInputContainer.vue
// module id = 2203
// module chunks = 1610